// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PdfProjectItemsQueryVariables = Types.Exact<{
  id: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type PdfProjectItemsQuery = { __typename?: 'Query', projectItems: Array<{ __typename?: 'ProjectItem', id: string, quantity?: number | null | undefined, displayName: string, totalCostInCents: number, specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, homeownerSelection?: { __typename?: 'HomeownerSelection', id: string, selectedOption?: { __typename?: 'HomeownerSelectionOption', id: string, product: { __typename?: 'Product', id: string, name: string, description?: string | null | undefined, manufacturerUrl?: string | null | undefined, sku?: string | null | undefined } } | null | undefined } | null | undefined, protoCommitmentLineItemToBuyout?: { __typename?: 'ProtoCommitmentLineItemToBuyout', specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, quantity?: number | null | undefined } | null | undefined }> };

export type PdfProjectItemFragment = { __typename?: 'ProjectItem', id: string, quantity?: number | null | undefined, displayName: string, totalCostInCents: number, specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, homeownerSelection?: { __typename?: 'HomeownerSelection', id: string, selectedOption?: { __typename?: 'HomeownerSelectionOption', id: string, product: { __typename?: 'Product', id: string, name: string, description?: string | null | undefined, manufacturerUrl?: string | null | undefined, sku?: string | null | undefined } } | null | undefined } | null | undefined, protoCommitmentLineItemToBuyout?: { __typename?: 'ProtoCommitmentLineItemToBuyout', specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, quantity?: number | null | undefined } | null | undefined };

export const PdfProjectItemFragmentDoc = gql`
    fragment PdfProjectItem on ProjectItem {
  id
  quantity
  unitOfMeasure {
    id
    name
  }
  displayName
  totalCostInCents
  specifications
  tradePartnerNote
  homeownerSelection {
    id
    selectedOption {
      id
      product {
        id
        name
        description
        manufacturerUrl
        sku
      }
    }
  }
  protoCommitmentLineItemToBuyout {
    specifications
    tradePartnerNote
    quantity
  }
}
    `;
export const PdfProjectItemsDocument = gql`
    query PdfProjectItems($id: [ID!]!) {
  projectItems(filter: {id: $id}) {
    ...PdfProjectItem
  }
}
    ${PdfProjectItemFragmentDoc}`;

/**
 * __usePdfProjectItemsQuery__
 *
 * To run a query within a React component, call `usePdfProjectItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdfProjectItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdfProjectItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePdfProjectItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PdfProjectItemsQuery, PdfProjectItemsQueryVariables> & ({ variables: PdfProjectItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PdfProjectItemsQuery, PdfProjectItemsQueryVariables>(PdfProjectItemsDocument, options);
      }
export function usePdfProjectItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PdfProjectItemsQuery, PdfProjectItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PdfProjectItemsQuery, PdfProjectItemsQueryVariables>(PdfProjectItemsDocument, options);
        }
// @ts-ignore
export function usePdfProjectItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PdfProjectItemsQuery, PdfProjectItemsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PdfProjectItemsQuery, PdfProjectItemsQueryVariables>;
export function usePdfProjectItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PdfProjectItemsQuery, PdfProjectItemsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PdfProjectItemsQuery | undefined, PdfProjectItemsQueryVariables>;
export function usePdfProjectItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PdfProjectItemsQuery, PdfProjectItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PdfProjectItemsQuery, PdfProjectItemsQueryVariables>(PdfProjectItemsDocument, options);
        }
export type PdfProjectItemsQueryHookResult = ReturnType<typeof usePdfProjectItemsQuery>;
export type PdfProjectItemsLazyQueryHookResult = ReturnType<typeof usePdfProjectItemsLazyQuery>;
export type PdfProjectItemsSuspenseQueryHookResult = ReturnType<typeof usePdfProjectItemsSuspenseQuery>;
export type PdfProjectItemsQueryResult = Apollo.QueryResult<PdfProjectItemsQuery, PdfProjectItemsQueryVariables>;